import { render, staticRenderFns } from "./ConceptMarketing.vue?vue&type=template&id=ff7fb8ee&scoped=true"
import script from "./ConceptMarketing.vue?vue&type=script&lang=ts"
export * from "./ConceptMarketing.vue?vue&type=script&lang=ts"
import style0 from "./ConceptMarketing.vue?vue&type=style&index=0&id=ff7fb8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7fb8ee",
  null
  
)

export default component.exports